export async function fetch(args) {
  try {
    const data = await args.apiMethod(args.requestArgs);
    return args.onSuccess(data);
  } catch (err) {
    args.alert.value = {
      message: err?.body?.message || err?.message || "An error occurred!",
      type: "danger"
    };
    if (args.onError) return args.onError(err);
  }
}
